import { useMemo } from "react";
import CalendarTodayIcon from "@material-ui/icons/CalendarToday";

const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];


export function CurrentDate() {
  const currentDate = useMemo(() => new Date(), []);

  return (
    <div
      className="ms-auto d-inline-flex align-items-center"
      style={{
        background: "rgba(255, 255, 255, 0.15)",
       
        height:"fit-content",
        backdropFilter: "blur(6px)",
        padding: "6px 12px",
        borderRadius: "999px",
        whiteSpace:"nowrap",
        color: "#fff",
        fontWeight: 700,
        fontSize: "0.95rem",
        border: "1px solid rgba(255,255,255,0.2)"
      }}
    >
      <CalendarTodayIcon
        style={{
          fontSize: "16px",
          marginRight: "6px",
          opacity: 0.9
        }}
      />

      {`${currentDate.getDate()} ${
        months[currentDate.getMonth()]
      } ${currentDate.getFullYear()}`}
    </div>
  );
}